import axios from '../../../config/axios'
import { BASE_URL_API } from '../../../config/env'
import { useMutation } from 'react-query'


export const useVineyardDeleteImageToGallery = (imageId) => {
    return useMutation(() => {
        return axios.delete(`${BASE_URL_API}/api/v1/admin/vineyard/remove-gallery-image/${imageId}`).then(({data}) => data)
    })
}